import styled from "styled-components";
import { motion } from "framer-motion";

export const Wrapper = styled(motion.div).attrs({
  className: "w-100 flex flex-column justify-center  ph4",
})`
  height: calc(100vh - 10vmin);
  margin-top: 10vmin;
`;

export const Count = styled(motion.div).attrs({ className: "w-100 mb4 ml2" })``;

export const Title = styled(motion.div).attrs({
  className: "w-100 pb5 bw3 bb b--black",
})``;

export const Logo = styled(motion.div).attrs({ className: "w-10 mt4" })``;
